<template>
    <div id="main_content" style="padding: 25vh 0 5rem 0;">
        <div class="section" style="border-bottom: 0;">
            <span class="title" style="padding: 0!important;">{{ t('login.title') }}</span>
            <form method="post" @submit="onSub">
                <div>
                    <Input id="username" v-model="username" name="meshkat_username" :placeholder="t('login.username')" dir="ltr" monospace />
                    <Input id="password" v-model="password" name="meshkat_password" :placeholder="t('login.password')" dir="ltr" type="password" />
                    <Input id="captcha" v-model="captcha" :placeholder="t('login.captcha')" dir="ltr" @keypress="onKeypressCaptcha" />
                    <img   id="captcha_img" :src="`${VUE_APP_SERVER_ROOT}captcha`" @click="refreshCaptcha" title="درصورت واضح نبودن روی تصویر کلیک کنید" data-bs-toggle="tooltip" data-bs-title="Tooltip on top" />
                </div>
                <button type="submit" class="more">{{ t('navbar.login') }}</button>
            </form>
            <p id="error_logging_in">{{ err }}</p>
        </div>
    </div>
</template>

<script setup>

import Input from '@/components/Input.vue'
import $ from 'jquery'
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

const { locale, t } = useI18n()
const $route = useRoute()

if ($route.params.locale) locale.value = $route.params.locale

let username = ref("")
let password = ref("")
let captcha = ref("")
const err = ref("")

const VUE_APP_SERVER_ROOT = process.env.VUE_APP_SERVER_ROOT

function refreshCaptcha($event) {
    $event.target.src = ""
    $event.target.src = `${process.env.VUE_APP_SERVER_ROOT}captcha?` + (Math.random() * 10000).toString(36)
}

function onKeypressCaptcha($event) {
    if(!Number($event.key + "1")) {
        $event.preventDefault()
    }
}

function onSub($event) {
    $event.preventDefault()
    $.ajax({
        url: `${process.env.VUE_APP_SERVER_ROOT}login`,
        method: "POST",
        data: {
            username: username.value,
            password: password.value,
            captcha: captcha.value
        },
        xhrFields: {
            withCredentials: true
        },
        dataType: "json",
        success(data) {
            if(!data.STATUS) {
                err.value = data.REASON;
                refreshCaptcha({ target: $("#captcha_img")[0] })
                captcha.value = ""
            } else {
                location.href = "/";
            }
        }
    })
}

onMounted(() => {
    $.ajax({
        url: `${process.env.VUE_APP_SERVER_ROOT}logout`,
        method: "GET",
        xhrFields: {
            withCredentials: true
        },
        dataType: "json",
        success(data) {
            if (data.STATUS) {
                location.href = location.href
            } else {
                err.value = data.REASON;
            }
        }
    })
})

</script>

<style lang="less" scoped>
    @bright: #F4FFFF;
    @azure: #F0FEFF;
    @lighter-nonphotoblue: #ACE6EF;
    @darker-nonphotoblue: #7CD0DE;
    @moonstone: #4BBACD;
    @teal: #2D7B88;
    @lighter-midnightgreen: #12535F;
    @darker-midnightgreen: #09353E;
    @rich-black: #00171D;

    .section {
        display: flex;
        flex-flow: column nowrap;
        justify-content: flex-start;
        align-items: center;

        #error_logging_in {
            color: red;
            font-weight: bold;
            font-size: 25px;
            margin-top: -1rem;
        }
        
        form {
            width: 53rem;
            max-width: 80vw;
            display: flex;
            flex-flow: column nowrap;
            justify-content: flex-start;
            align-items: center;

            &>div {
                // display: flex;
                // flex-flow: row wrap;
                // justify-content: space-evenly;
                // align-items: stretch;
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                grid-template-rows: repeat(2, 1fr);
                justify-items: center;
                align-items: stretch;
                width: 850px;
                max-width: 90vw;
                // margin: 0 auto;

                @media only screen and (max-width: 1024px) {
                    grid-template-columns: auto;
                    grid-template-rows: repeat(4, 1fr);
                }

                input, img {
                    margin-top: 1rem;
                    width: 400px;
                    max-width: 90vw;
                    // width: 25rem;
                }

                img {
                    border-radius: 10px;
                }
            }            

            .btn-submit {
                border: none;
                border-radius: 10px;
                background-color: @lighter-midnightgreen;
                color: @azure;
                font-weight: bold;
                padding: 1.5vh 3vw;
                margin-top: 1rem;
                margin-left: 8vw;
                transition: background .3s ease-in-out;
                align-self: flex-end;

                @media only screen and (max-width: 1024px) {
                    padding: auto;
                    align-self: center;
                    margin: 1rem 0;
                    width: 400px;
                    max-width: 90vw;
                }

                &:hover {
                    background-color: @darker-midnightgreen;
                }
            }
        }
    }
</style>